import React, { Component } from "react";
import { Modal, Button, Image, Table } from "semantic-ui-react";
import QuickTipsImage from "../../assets/images/quick_tip.png";
import { getQuickTips } from "../forms/QuickTips";

class QuickTips extends Component {
  componentDidMount() {}
  render() {
    const tipKey = `${this.props.currentMenuHierarchy[0]}_${this.props.currentMenuHierarchy[1]}_${this.props.currentFormTitle}`;
    const tips = getQuickTips(tipKey);
    // const header = tips[0];
    let contents = [];
    const { userAccount } = this.props;
    if (tips.length > 0) {
      contents = tips.slice(1, tips.length);
    }
    return (
      <Modal
        className={"dialog-quicktip-render"}
        trigger={
          <Button
            primary={false}
            className={
              userAccount.acctTheme === 0
                ? "coverageHREF2 orangeShadowBorder darkFont"
                : "tips-search-button"
            }
            onClick={() => this.props.openQuickTipsDialog()}
          >
            Tips For Better Results
          </Button>
        }
        closeIcon
        open={this.props.active}
        onClose={() => this.props.closeQuickTipsDialog(this)}
      >
        <Modal.Header>Tips For Better Results</Modal.Header>
        <Modal.Content image scrolling>
          <Image wrapped size="tiny" src={QuickTipsImage} />
          <Modal.Description>
            <Table className="table-no-border">
              <Table.Body>
                {/* <Table.Row>
                  <Table.Cell className={"text-center"}>{header}</Table.Cell>
                </Table.Row> */}
                <Table.Row>
                  <Table.Cell>{<ul>{contents}</ul>}</Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions className={"dialog-actions"}>
          <Button
            className={"no-background-color float-right"}
            onClick={() => this.props.closeQuickTipsDialog(this)}
          >
            Done
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default QuickTips;



// WEBPACK FOOTER //
// ./src/components/dialogs/QuickTips.js